import React from 'react';
import { LoginPage } from '../features/auth/LoginPage';

/**
 * Wrapper para manter compatibilidade de rota (`/pages/Login.tsx`)
 * enquanto a implementação real da página fica em `features/auth/LoginPage`.
 */
const Login: React.FC = () => {
  return <LoginPage />;
};

export default Login;
